import { useMemo } from 'react';
import { useCtx } from './ctx';

export const useGetSortHeader = () => {
    const [state] = useCtx();

    return useMemo(() => state.sortHeader, [state.sortHeader]);
};

export const useGetSortAsc = () => {
    const [state] = useCtx();

    return useMemo(() => state.sortAsc, [state.sortAsc]);
};
